<template>
  <div>
    <div class="ads" v-html="strHtml"></div>
    <div style="text-align: center;margin-top: 20px;">
      <el-button type="primary" style="width: 110px;margin-left: 5px;" @click="toPage('/entrust')">立即下单</el-button>
      <el-button type="success" style="width: 110px;" @click="toPage('/consulting')">在线咨询</el-button>
      <el-button v-if="!vipInfo || !vipInfo.vipEdate" type="warning" style="margin-top: 5px;width: 230px;" @click="toPage('/userCenter/vipLevel')">开通会员</el-button>
    </div>
  </div>
</template>

<script>
import { getLists } from '@/api/ads/adsTexts'

export default {
  name: 'index',
  data () {
    return {
      strHtml: '',
      param: {
        categoryCode: 'ad_right'
      }
    }
  },
  mounted () {
    this.getInfo()
  },
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo
    },
    companyInfo () {
      return this.$store.state.user.companyInfo
    },
    isLogin () {
      return this.$store.state.user.isLogin
    },
    vipInfo () {
      return this.$store.state.user.vipInfo
    }
  },
  methods: {
    toPage (path) {
      window.open(path)
    },
    getInfo () {
      getLists(this.param).then(res => {
        var result = res.data
        if (result.rtnCode === '0') {
          if (result.bizData && result.bizData.length > 0) {
            this.strHtml = result.bizData[Math.floor(Math.random() * result.bizData.length)].content
          }
        } else {
          this.$message.error(result.bizMsg)
        }
      }).catch(() => {
        this.$message.error('加载失败')
      })
    }
  }
}
</script>

<style scoped>

</style>
